<mat-option
  (onSelectionChange)="multiSelect().toggleSelectAll($event.source.selected)"
  [disabled]="multiSelect().filtered()"
  >Select all
</mat-option>
